// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 19:53:22

export default {
  "id": "mystical-blade-3d",
  "slug": "mystical-blade-3d",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/ba43bd6b97a942f0a7d5c8de69c8e1be-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/ba43bd6b97a942f0a7d5c8de69c8e1be/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Mystical Blade 3D",
      "description": "Enter the world of Mystical Blades, where you design and battle your own B-Blades! Mix blades, rings, and elements to create powerful combos, then face players worldwide in thrilling battles. With stunning graphics and realistic physics, prove your skills and become the ultimate B-Blades master!",
      "instructions": "Use the mouse or touchscreen to play the game.\n\n",
      "genres": [
        "Adventure",
        "Simulation"
      ],
      "tags": [
        "3d",
        "animal",
        "arena",
        "competition"
      ]
    },
    "zh-CN": {
      "title": "神秘之刃3D",
      "description": "进入神秘之刃的世界，在这里你将设计和战斗属于你自己的B-Blades！混合刀刃、戒指和元素，创造强大的连招，然后在全球范围内与玩家进行激动人心的战斗。凭借惊人的图形和逼真的物理效果，证明你的技巧，成为终极B-Blades大师！",
      "instructions": "使用鼠标或触摸屏来玩游戏。",
      "genres": [
        "冒险",
        "模拟"
      ],
      "tags": [
        "3D",
        "动物",
        "竞技场",
        "比赛"
      ]
    },
    "zh-TW": {
      "title": "神秘之劍3D",
      "description": "進入神秘之劍的世界，您可以設計和戰鬥屬於自己的B-Blades！混搭劍刃、指環和元素，創造強大的組合，然後在刺激的戰鬥中與全球玩家一較高下。擁有驚人的圖形和逼真的物理效果，證明您的技能並成為無敵的B-Blades大師！",
      "instructions": "使用滑鼠或觸控螢幕來玩遊戲。",
      "genres": [
        "冒險",
        "模擬"
      ],
      "tags": [
        "3D",
        "動物",
        "競技場",
        "競賽"
      ]
    },
    "zh-HK": {
      "title": "神秘之劍3D",
      "description": "進入神秘劍的世界，打造及戰鬥你自己的B-Blades！混搭劍刃、戒指及元素，創造強大的組合，然後在刺激的戰鬥中對抗全球玩家。擁有驚艷的圖像和真實的物理效果，展現你的技巧，成為無敵的B-Blades大師！",
      "instructions": "使用滑鼠或觸控屏來玩遊戲。",
      "genres": [
        "冒險",
        "模擬"
      ],
      "tags": [
        "3D",
        "動物",
        "鬥場",
        "競賽"
      ]
    },
    "ja": {
      "title": "霊的な剣3D",
      "description": "神秘の刃の世界へ入って、あなた自身のB-Bladesをデザインし戦いましょう！剣、リング、要素を組み合わせて強力なコンボを作成し、世界のプレイヤーと迫力あるバトルに挑んでください。驚くべきグラフィックとリアルな物理シミュレーションで、あなたのスキルを証明し究極のB-Bladesマスターに！！！",
      "instructions": "マウスやタッチスクリーンを使ってゲームを遊んでください。",
      "genres": [
        "アドベンチャー",
        "シミュレーション"
      ],
      "tags": [
        "3D",
        "動物",
        "アリーナ",
        "競技"
      ]
    },
    "ko": {
      "title": "마이스틱 블레이드 3D",
      "description": "신비한 검의 세계에 오세요! 자신만의 B-Blades를 디자인하고 전투하세요! 검, 반지, 요소를 혼합하여 강력한 콤비를 만들어 전 세계의 플레이어들과 흥미진진한 전투에 맞서세요. 인상적인 그래픽과 실제적인 물리학으로 능력을 입증하고 최고의 B-Blades 마스터가 되세요!",
      "instructions": "마우스나 터치스크린을 사용하여 게임을 플레이하세요.",
      "genres": [
        "모험",
        "시뮬레이션"
      ],
      "tags": [
        "3D",
        "동물",
        "경장",
        "경쟁"
      ]
    },
    "fr": {
      "title": "Lame Mystique 3D",
      "description": "Entrez dans le monde des Lames Mystiques, où vous concevez et combattez vos propres B-Blades ! Mélangez des lames, des anneaux et des éléments pour créer des combos puissants, puis affrontez des joueurs du monde entier dans des batailles époustouflantes. Avec des graphismes stupéfiants et une physique réaliste, prouvez vos compétences et devenez le maître ultime des B-Blades !",
      "instructions": "Utilisez la souris ou le tactile pour jouer au jeu.",
      "genres": [
        "Aventure",
        "Simulation"
      ],
      "tags": [
        "3D",
        "animal",
        "arène",
        "compétition"
      ]
    }
  }
};
